import { renderToString } from 'react-dom/server';
import { getPartnerColorClasses } from '@utils/findPartner';
import { DropLocationSVG, DropLocationSVGWithOpacity } from '@components/svgs';

export const locationIconRender = (h = '30px', icon_color) => {
  return renderToString(
  
      <DropLocationSVG height={h} color={icon_color} />
  );
};

export const getInfoboxTemplate = content => {
  const { name, travelDistance, address, phone, accountSupType } = content;
  return `<section class='flex flex-col bg-[#f5f5f5] p-4 border cursor-text'>
    <div class='text-lg font-ProMedium font-bold'>${name?.toUpperCase()}</div>
    <div class='flex justify-between mt-2.5'>
      <div class='flex uppercase font-bold text-xs'>
        <span class='${getPartnerColorClasses(accountSupType)}'>
          ${accountSupType ? accountSupType : ''}
        </span>
        
      </div>
      <div class='flex font-semibold'>
        <span class='text-xs'>${travelDistance} mi</span>
      </div>
    </div>
    <div class='mt-[15px] text-xs'>
      <div class='flex flex-row justify-between'>
          <div>${address}</div>
      </div>
      <div class='flex flex-row justify-between'>
            <div class="flex flex-col gap-2">
                <a
                    href=tel:${phone}
                    class='underline underline-offset-4 font-bold tracking-widest cursor-pointer'
                >
                    ${phone ? phone : ''}
                </a>
            </div>
        </div>
      </div>
    </div>
  </section>`;
};

export const getDealerPopUpContent = properties => {
  const { name, travelDistance, phone, accountSupType, address } = properties;
  return `<section class='flex flex-col bg-[#f5f5f5] p-4 border'>
     <div class='text-lg font-ProMedium font-bold'>${name?.toUpperCase()}</div>
     <div class='flex justify-between my-2.5'>
     <span class='${getPartnerColorClasses(accountSupType)}'>
          ${accountSupType ? accountSupType : ''}
        </span>
         <div class='flex font-semibold'>
        <span class='text-xs'>${travelDistance}</span>
      </div>
    </div>
     <div class='mt-[15px] text-xs'>
      <div class='flex flex-row justify-between'>
          <div> ${address}</div>
      </div>
  <div class='flex flex-row justify-between'>
            <div class="flex flex-col gap-2">
                <a
                    href=tel:${phone}
                    class='underline underline-offset-4 font-bold tracking-widest cursor-pointer'
                >
                    ${phone ? phone : ''}
                </a>
            </div>
        </div>
      </div>
  </section>`
};

export const updateAdobeDataLayer = async (url) => {
  const getPathName = url.split("/").filter(Boolean);
  const extractLangCode = getPathName[0] || "";
  const hasLangCode = extractLangCode.length === 2 || (extractLangCode.length === 5 && extractLangCode[2] === "-");
  const langCode = hasLangCode ? getPathName.shift() : 'en-US';
  typeof window !== 'undefined' && (globalThis.adobeDataLayer = globalThis.adobeDataLayer || [])
  adobeDataLayer.length = 0;
  adobeDataLayer.push({
    "event": "Page Loaded",
    "page": {
      "pageInfo":
      {
        "pageName": "find-a-dealer",
        "pageType": "Content Page",
        "siteLanguage": langCode
      },
    }
  });
}